var _path, _path2, _g, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b7e4f8",
    d: "M0 191.94h512v254H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6fc8f1",
    d: "M256 191.94h256v254H256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#132f3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.67 273.77h198.67v30H238.67zM309.33 334.11h128v30h-128z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffdb2d",
    d: "M374.17 66.06L188.519 313.488l6.391 44.802 44.801-6.391L425.362 104.47z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7b00",
    d: "M188.519 313.488l6.391 44.802 44.801-6.391z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4f19",
    d: "M345.941 210.32l79.421-105.85-51.192-38.41-79.422 105.85 51.192 38.41z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.878 367.403v14.985H96.844v-14.31c-13.499-.81-26.594-4.455-34.693-9.45l10.26-23.219c8.909 5.265 20.789 8.64 31.184 8.64 9.045 0 12.284-1.89 12.284-5.13 0-11.88-52.242-2.295-52.242-37.529 0-15.254 11.069-28.079 33.208-31.184v-14.714h19.034v14.445c9.99.945 19.71 3.51 27.404 7.83l-9.585 23.084c-9.314-4.725-18.089-7.02-26.323-7.02-9.315 0-12.285 2.7-12.285 5.94 0 11.339 52.243 1.89 52.243 36.719-.001 14.579-10.53 27.269-31.455 30.913z",
    fill: "#265d77"
  })));
}

export default __webpack_public_path__ + "2a145b1ff8003652ed50754d3c680e5d.svg";
export { SvgCheck as ReactComponent };